<template>
  <div class="dropdown nav-item language-dropdown btn-group d-md-flex d-none">
    <a
      id="ddllang"
      href="#"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      class="btn dropdown-toggle btn-icon-only nav-link"
      :aria-label="changeLanguageLabel"
    >
      <img
        v-if="selectedLang && selectedLang.code"
        :src="flagSrc(selectedLang.code)"
        class="flag-width"
        alt=""
        @error="flagError($event, selectedLang.code)"
      />
    </a>
    <ul class="dropdown-menu" :class="{ isNotUser: !isUser }" aria-labelledby="ddllang">
      <perfect-scrollbar>
        <li v-for="item in countryList" :key="item.code">
          <a
            href="javascript:;"
            class="dropdown-item d-flex align-items-center"
            :class="{ active: $i18n.locale === item.code }"
            @click.prevent="changeLanguage(item)"
          >
            <img :src="flagSrc(item.code)" class="flag-width" alt="" @error="flagError($event, item.code)" />
            <span>{{ $t("global.language." + item.name.toLowerCase()) }}</span>
          </a>
        </li>
      </perfect-scrollbar>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useThemeStore } from "@/store/theme/theme";
import { usePlatformStore } from "@/store/platform/platform";

export default {
  name: "SelectLanguageComponent",
  props: {
    isUser: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedLang: {},
    };
  },
  computed: {
    changeLanguageLabel() {
      const language = this.selectedLang?.name
        ? this.$t("global.language." + this.selectedLang.name.toLowerCase())
        : "";
      return this.$t("global.language.change", { language });
    },

    ...mapState(useThemeStore, {
      countryList: (store) => store.countryList,
    }),
    ...mapState(usePlatformStore, {
      spanishFlag: (store) => store.design?.spanishFlag,
    }),
  },
  mounted() {
    this.selectedLang = window.$appSetting.toggleLanguage();
  },
  methods: {
    flagSrc(code) {
      const flag = code === "es" && this.spanishFlag ? this.spanishFlag : code;
      return "/assets/images/flags/" + flag + ".png";
    },

    flagError(event, code) {
      const fallback = "/assets/images/flags/es.png";
      if (code === "es" && !event.target.src.endsWith(fallback)) {
        event.target.src = fallback;
      }
    },

    changeLanguage(item) {
      this.toggleLocal(item.code);
      this.selectedLang = item;
      window.$appSetting.toggleLanguage(item);
      this.$i18n.locale = item.code;
      location.reload();
    },

    ...mapActions(useThemeStore, { toggleLocal: "toggleLocal" }),
  },
};
</script>

<style lang="scss" scoped></style>
